export const approvalsTabUIInitialState = {
  showTransferApprovalModal: false,
  activeApprovalTab: "approvals",
  showApprovalsDelForm: false,
  showApprovedDelForm: false,
};
